import { render } from "./TimeRegistration.vue?vue&type=template&id=3a63565d&scoped=true"
import script from "./TimeRegistration.vue?vue&type=script&lang=js"
export * from "./TimeRegistration.vue?vue&type=script&lang=js"

import "./TimeRegistration.vue?vue&type=style&index=0&id=3a63565d&scoped=true&lang=css"
import "./TimeRegistration.vue?vue&type=style&index=1&id=3a63565d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a63565d"]])

export default __exports__